import TaxonomyPage from "./TaxonomyPage";
import PhotoManager from "./PhotoManager";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  apiListBrands, apiCreateBrand, apiUpdateBrand, apiDeleteBrand, apiReorderBrands,
  apiBrandProducts, apiSetBrandOrder,
} from "../adminApi";

export default function Brands() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight text-chalk">Marchi</h1>
        <p className="mt-1 text-sm text-steel">Gestisci la foto profilo, l'ordine e i prodotti dei marchi del catalogo.</p>
      </div>

      <Tabs defaultValue="foto">
        <TabsList data-testid="brands-tabs">
          <TabsTrigger value="foto" data-testid="brands-tab-foto">Foto marchi</TabsTrigger>
          <TabsTrigger value="elenco" data-testid="brands-tab-elenco">Elenco e ordine</TabsTrigger>
        </TabsList>

        <TabsContent value="foto" className="mt-5">
          <PhotoManager
            list={apiListBrands}
            update={apiUpdateBrand}
            imageField="logo"
            labelField="name"
            uploadFolder="rinova/brands"
            uploadContext="card"
            testPrefix="brandphoto"
            intro="Carica la foto profilo di ogni marchio (appare come box nel Catalogo) e regola la proporzione. L'anteprima mostra come apparirà sul sito."
          />
        </TabsContent>

        <TabsContent value="elenco" className="mt-5">
          <TaxonomyPage
            title="Marchi"
            subtitle="Gestisci i marchi del catalogo."
            nameLabel="Nome marchio"
            nameField="name"
            testidPrefix="brand"
            hideHeader
            api={{
              list: apiListBrands,
              create: apiCreateBrand,
              update: apiUpdateBrand,
              remove: apiDeleteBrand,
              reorder: apiReorderBrands,
              products: apiBrandProducts,
              setOrder: apiSetBrandOrder,
            }}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
